import filterMixin from './filter-mixin';
export class FilterBuilder extends filterMixin() {
    get constructorName() {
        return 'FilterBuilder';
    }
    _build() {
        return this.getFilterModel();
    }
}
export function filterBuilder(params = {}) {
    return new FilterBuilder(params);
}
export default filterBuilder;
//# sourceMappingURL=filter-builder.js.map